// constants/auth.ts
export const TOKEN_KEY = "ittelecom_access_token";
export const REFRESH_TOKEN_KEY = "ittelecom_refresh_token";
export const USER_KEY = "ittelecom_user";